import React, { FocusEvent } from "react";
import { Row, Col } from "react-bootstrap";
import { ActionHandlerFunction, Sort } from "@preveil-api";
import { DriveUIActionTypes, getSelectedState, SORT_DIRECTION } from "src/common";
import { Checkbox, Icon, Loading } from "src/components";
import { ListRow, NoAddressesView } from "..";
import _ from "lodash";

type AllProps = {
  is_loading: boolean;
  groups_aliases: string[];
  selected: string[];
  sort: Sort<string>;
  handleAction: ActionHandlerFunction;
};

// Description: ListViewComponent is a React component that renders a list of user groups with checkboxes for selection.
function ListViewComponent(props: AllProps) {
  const { is_loading, selected, groups_aliases, sort, handleAction } = props;

  // Description: Render the rows of Admin Users view
  function RenderList(_list: string[]) {
    return (
      <div className="list-body">
        {_.map(_list, (_group_name: string, i: number) => {
          return (
            <ListRow
              key={`item_${i}`}
              group_name={_group_name}
              handleAction={handleAction}
              selected={selected.includes(_group_name)}
            />
          );
        })}
      </div>
    );
  }

  return <div className={`admin-list-view ${is_loading ? " isloading" : ""}`}>
    {!!groups_aliases && groups_aliases.length > 0 && (
      <Row className="header-row">
        <Col md="1">
          <Checkbox
            className="sr-only"
            onChange={(e: FocusEvent<HTMLInputElement>) => {
              handleAction({
                actionType: DriveUIActionTypes.Select,
                params: { selected: e.target.checked },
              });
            }}
            value="all"
            label="Select All"
            selected={getSelectedState(selected, groups_aliases.length)}
          />
        </Col>
        <Col md="5" className="col" onClick={() => handleAction({ actionType: DriveUIActionTypes.SetSort, params: "address" })}>
          User Group Email Address/Domain
          {!!sort && sort.field === "address" && groups_aliases.length > 1 && (
            <Icon className={`${sort.direction === SORT_DIRECTION.descending ? "ficon-arrow-down" : "ficon-arrow-up"} small-icon ps-1`} />
          )}
        </Col>
      </Row>
    )}
    {!!groups_aliases && groups_aliases.length > 0 ? (
      RenderList(groups_aliases)
    ) : !is_loading ? <NoAddressesView handleAction={handleAction} /> : null}

    {is_loading && <Loading />}
  </div>;
}

export default React.memo(ListViewComponent);
